<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :isRequiredLots="false"
              :filterOfWorkers="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
              classLots="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
              classWorkers="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
              ref="filters"
            >
              <template slot="prev">
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                  <label for="">{{ $t('common_words.activities') }}: </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('dataFilter.activities', activities)
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.activities"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in activities"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 pt-3">
                  <label for="">{{ $t('labor.hour_type') }}: </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('dataFilter.timeTypes', timeTypes)
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.timeTypes"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in timeTypes"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <card v-if="tableData.length > 0">
        <br />
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-1"
          ></card-header>
          <master-table
            :cellStyle="handleCellStyle"
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="false"
          >
            <template slot="addColumnsOperations">
              <el-table-column
                v-if="closings()"
                :min-width="110"
                prop="closing"
                label=""
                :align="`center`"
                fixed="right"
              >
                <template slot-scope="props">
                  <button-closing
                    :dataClosing="props"
                    @updateTable="updateTable"
                    @showHideLoading="showHideLoading"
                    @showOrHideOperationColumn="showOrHideOperationColumn"
                  />
                </template>
              </el-table-column>
              <table-columns-operations
                v-if="isShow() || isDelete()"
                @handleView="handleView"
                @handleDelete="handleDelete"
                :showOperationEdit="false"
                :canDisable="false"
                :minWidth="120"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <div class="mt-3">
          <div class="align-exportable">
            <div class="px-3" v-if="isPDF()">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDFHeader"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
            <div class="px-3" v-if="isExcel()">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportXLSHeader()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
            <div class="px-3">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                style="
                  background-color: #0079c1 !important;
                  border-color: #0079c1 !important;
                "
                @click="exportToSAP()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_sap') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </card>
      <div v-if="details" class="col-12 text-center">
        <em
          class="nc-icon nc-stre-up"
          style="font-size: 25px; cursor: pointer"
          @click="handleViewDetails"
          v-tooltip.top-center="$t('common_words.hide_detail')"
        ></em>
      </div>
      <card v-if="details && rowData">
        <div class="row">
          <div class="col-12">
            <p style="font-size: 17px" class="text-muted">
              {{ $t('labor.worker_detail_info') }}
            </p>
          </div>
          <div class="col-12 col-xl-10">
            <div class="table-responsive">
              <table aria-describedby="table-details" class="table">
                <tbody>
                  <tr class="shadow-sm">
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.code') }}:</strong>
                      </h6>
                      {{ rowData.id }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.farm') }}:</strong>
                      </h6>
                      {{ rowData.farm.name }}
                    </td>
                    <td>
                      <h6>
                        <strong
                          >{{ $t('common_words.code') }} -
                          {{ $t('labor.worker') }}:</strong
                        >
                      </h6>
                      {{ rowData.worker.code }} -
                      {{ rowData.worker.first_name }}
                      {{ rowData.worker.last_name }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.save_date') }}:</strong>
                      </h6>
                      {{ rowData.date_save }} | {{ $t('common_words.week') }}:
                      {{ rowData.week_save }}, {{ $t('common_words.day') }}:
                      {{ rowData.day_save }}
                    </td>
                    <th>
                      <img
                        v-tooltip.top-center="
                          $t('common_words.geo_location_labor_detail')
                        "
                        style="width: 30px; height: 30px"
                        class="pointer"
                        src="/static/img/iconos/map.svg"
                        alt="Icono de Geolocalización"
                        @click="openMap()"
                      />
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <el-dialog
            :title="$t('common_words.samples_map')"
            class="zoom-map el-dialog-img-zoom"
            top="15px"
            width="80%"
            :visible.sync="modals.map"
            :close="closeMap"
          >
            <multiple-map ref="map" :height="800" />
          </el-dialog>
        </div>
        <div v-if="isShow()" class="row">
          <div v-if="isShow()" class="col-12">
            <card-header
              :propPagination="paginationDetails"
              @searchedQuery="searchedQueryDetails"
              class="mr-3 mt-4"
            ></card-header>
            <master-table
              :cellStyle="handleCellStyle"
              :infoTable="queriedDataDetails"
              :columns="tableColumnsDetails"
              :showColumnStatus="false"
            >
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="
                    (isUpdate() || isDelete()) && this.rowData.closing === 0
                  "
                  :canShow="false"
                  :minWidth="150"
                  :showOperationEdit="true"
                  @handleDelete="handleDeleteDetails"
                  @handleEdit="handleEditDetails"
                >
                  <template v-slot:append="props">
                    <a
                      v-if="
                        renderComponent &&
                        showIconIncrement(props.dataProps.row)
                      "
                      v-tooltip.top-center="
                        getTooltipIncrement(props.dataProps.row)
                      "
                      :class="`btn-${getColorIncrement(
                        props.dataProps.row
                      )} btn-simple btn-link custom-margin-actions`"
                      @click="hanldeIncrement(props.dataProps.row)"
                    >
                      <em
                        :class="`fa ${getIconIncrement(
                          props.dataProps.row
                        )} custom-size-fa-actions`"
                        aria-hidden="true"
                      ></em>
                    </a>
                  </template>
                </table-columns-operations>
              </template>
            </master-table>
          </div>
          <not-index-permissions v-else />
          <card-footer
            :propPagination="paginationDetails"
            ref="cardfooterdetail"
          />
        </div>
        <export-tables
          :pdf="{
            filename: `${$t('common_words.activity_details')}.pdf`,
            route: 'works/labordetails/pdf',
            paramMethod: 'POST',
            plusData: { codeDetail: this.rowData.id },
          }"
          :xls="{
            filename: `${$t('common_words.activity_details')}.xlsx`,
            route: 'works/labordetails/excel',
            paramMethod: 'POST',
            plusData: { codeDetail: this.rowData.id },
          }"
        />
        <br />
      </card>
      <el-dialog
        v-if="isUpdate()"
        :title="$t('common_words.activity_report_edit')"
        :visible.sync="modals.read"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="45%"
        top="2%"
      >
        <job-editing-form
          :detail="model"
          :activities="activities"
          :timetypes="timeTypes"
          :workers="getWorkerToProps"
          @showMessageErrors="showMessageErrors"
          @showHideLoading="showHideLoading"
          @closeModal="closeModal"
          @updateRow="updateRow"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import Closing from './Closing';
import configTable from './activities-report-table';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import JobEditingForm from './JobEditingForm';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinCalculateExtraHourWeek from './mixin-calculate-extra-hours-week';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinUpdateRow from './mixin-update-row';
import MixinExportReport from './mixin-export-report';
import moment from 'moment';
import MultipleMap from './MultipleMap.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    [MultipleMap.name]: MultipleMap,
    [JobEditingForm.name]: JobEditingForm,
    [Closing.name]: Closing,
    LPagination,
  },

  data() {
    return {
      activeName: 'filter',
      activities: [],
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        labors: [],
        farm: [],
        lot: [],
        timeTypes: [],
        activities: [],
        workers: [],
      },
      details: false,
      detailsForm: {},
      fuseSearchDetails: null,
      model: null,
      paginationDetails: {},
      reportType: 0,
      searchQueryDetails: '',
      tableColumns: [],
      tableColumnsDetails: [],
      tableDataDetails: [],
      timeTypes: [],
      valueCollapse: null,
      workers: [],
      extraHoursByWeek: null,
    };
  },

  computed: {
    ...configTable().SearchDetails,
    getDataToExport() {
      const response = { ...this.dataFilter };
      delete response.route;

      return response;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    getWorkerToProps() {
      return [...this.workers].splice(1);
    },
  },

  mixins: [
    MixinMasters,
    MixinMenu,
    MixinPermissions,
    MixinArcgisMap,
    MixinUpdateRow,
    MixinCalculateExtraHourWeek,
    MixinExportReport,
  ],
  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.workers = this.concatAll(this.workers.splice(1));
      this.activities = this.concatAll(this.activities.splice(1));
      this.timeTypes = this.concatAll(this.timeTypes.splice(1));
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleFilter(data) {
      this.dataFilter = { ...this.dataFilter, ...data };
      this.details = false;
      this.getDataSamples();
    },

    getExtraWeekHours(row) {
      return this.extraHoursByWeek
        .filter((item) => item.week_save === row.week_save)
        .reduce((acc, item) => acc.concat(item.workers), [])
        .filter((item) => item.worker_id === row.worker_id)
        .reduce((acc, item) => acc + item.total_extra_day_hours, 0);
    },

    getExtraWeekHourExceedByWorker(row) {
      const match = this.extraHoursByWeek
        .filter((item) => item.week_save === row.week_save)
        .reduce((acc, item) => acc.concat(item.workers), [])
        .find((item) => item.worker_id === row.worker_id);

      return match ? match.is_extra_week_hour_exceed : null;
    },

    getDataSamples() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'works/laborheaders';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data.labor_data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('sweet_alert.jobs.unavailable_data'));
          } else {
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
            this.extraHoursByWeek = response.data.data.extra_hours_by_week;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleView(index, row) {
      this.showHideLoading(true);
      this.details = false;
      this.rowData = row;
      this.rowData.index = index;

      this.tableData.forEach((element) => {
        if (element.id != this.rowData.id) element.show = true;
        else this.rowData.show = false;
      });

      Promise.all([Axios.getMasters('works/labordetails/' + this.rowData.id)])
        .then((response) => {
          const [responseDetails] = response;
          this.tableDataDetails = responseDetails.data.data;
          this.fuseSearchDetails = new Fuse(this.tableDataDetails, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumnsDetails.map((prop) => {
              return prop.prop;
            }),
          });
          this.details = true;
          this.paginationDetails.perPage = 5;
          this.paginationDetails.currentPage = 1;

          this.showHideLoading();

          setTimeout(() => {
            window.scrollTo({
              top: document.getElementsByClassName('footer')[0].offsetTop - 500,
              behavior: 'smooth',
            });
          }, 100);
        })
        .catch((error) => {
          this.showHideLoading();
          this.rowData.show = true;
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleDelete(_, row) {
      this.model = row;
      SweetAlert.delete(
        `${i18n.t('sweet_alert.jobs.worker_labor')} <br/>"${
          this.model.worker.first_name
        } ${this.model.worker.last_name}"`
      ).then((result) => {
        if (result.value) this.deleteActivityReport();
      });
    },

    updateTable(data) {
      this.modifyTable(data.type, data.id, data.response);
    },

    showOrHideOperationColumn(showOrhide) {
      this.$set(this.rowData, 'closing', showOrhide ? 1 : 0);
    },

    searchedQueryDetails(searchedValue) {
      this.searchQueryDetails = searchedValue;
    },

    getBusinessCode(businesses) {
      const result = businesses.filter((business) => business.id !== 1);
      let code = '';
      if (result && result.length > 0) {
        code = result[0].code ? result[0].code : '';
      }

      return result && result.length > 0 ? code : '';
    },

    showIconIncrement(row) {
      const { increment_rates } = row;
      return increment_rates && increment_rates.length > 0;
    },

    getTooltipIncrement(row) {
      const { add_increment } = row;
      return `${add_increment ? `Restar` : `Sumar`} Acréscimos`;
    },

    getIconIncrement(row) {
      const { add_increment } = row;
      return `${add_increment ? `fa-minus-circle` : `fa-plus-circle`}`;
    },

    getColorIncrement(row) {
      const { add_increment } = row;
      return `${add_increment ? `warning` : `info`}`;
    },

    hanldeIncrement(row) {
      const { add_increment, id, increment_rates, quantity, subtotal } = row;
      const isSum = add_increment;
      const increment = increment_rates
        ? increment_rates.reduce(
            (acc, rate) => Number(rate.rate_value) + acc,
            0
          )
        : 0;
      let sub = !isSum
        ? subtotal + increment * quantity
        : subtotal - increment * quantity;

      this.showHideLoading(true);
      const payload = {};
      payload.route = 'works/labordetails/update/increment';
      payload.id = id;
      payload.add_increment = !isSum;

      Axios.updateMaster(payload).then(() => {
        this.modifyTable(
          1,
          id,
          {
            data: {
              data: { ...row, add_increment: !isSum, subtotal: sub },
              message: i18n.t('message.msg.modified_subtotal'),
            },
          },
          null,
          null,
          null,
          this.tableDataDetails
        );

        this.updateTableData();
        this.forceRerender();
        this.showHideLoading();
      });
    },

    calculateSubtotal(row, message, extraHour = false, updateTable = true) {
      const {
        add_increment,
        id,
        increment_rates,
        quantity,
        time_type,
        value_time_type,
        activity,
      } = row;
      const { activity_values } = activity;
      const increment = increment_rates
        ? increment_rates.reduce(
            (acc, rate) => Number(rate.rate_value) + acc,
            0
          )
        : 0;

      let sub = activity_values[0] ? activity_values[0].price * quantity : 0;

      if (extraHour && time_type && value_time_type) {
        if (time_type.price_format === '%') {
          sub += sub * (value_time_type.additional_percentage / 100);
        } else {
          sub += quantity * value_time_type.additional_percentage;
        }
      }

      sub += add_increment ? increment * quantity : 0;

      this.modifyTable(
        1,
        id,
        {
          data: {
            data: { ...row, subtotal: sub },
            message,
          },
        },
        null,
        null,
        null,
        this.tableDataDetails
      );

      if (updateTable) this.updateTableData();
      this.forceRerender();
    },

    updateTableData() {
      const indexData = this.tableData.findIndex(
        (data) => data.id === this.rowData.id
      );
      this.$set(this.tableData, indexData, {
        ...this.rowData,
        labor_details: this.tableDataDetails,
      });
    },

    openMap() {
      this.modals.map = true;
      this.showHideLoading(true);

      let points = [];
      this.tableDataDetails.forEach((element) => {
        let pll = new Object();
        pll.lat = parseFloat(element.latitude);
        pll.lng = parseFloat(element.longitude);

        this.center.lat = element.latitude
          ? parseFloat(element.latitude)
          : this.center.lat;
        this.center.lng = element.longitude
          ? parseFloat(element.longitude)
          : this.center.lng;

        points.push(pll);
      });

      setTimeout(() => {
        this.loadBaseMap(
          this.rowData.farm_id,
          true,
          true,
          this.$refs.map.$refs.multipleMap,
          points,
          19
        );
        try {
          document.getElementById('toolbarDiv').style = 'top: 16%;right: 18px;';
        } catch (error) {
          //
        }
        this.showHideLoading();
      }, 10);
    },

    closeMap() {
      this.modals.map = false;
    },

    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        element.show = true;
      });
    },

    handleEditDetails(index, row) {
      this.title = i18n.t('common_words.report_edit_activity') + row.name;
      this.model = { header: { ...this.rowData }, ...row };
      this.model.index = index;
      this.model.route = 'works/labordetails';
      this.modals['read'] = true;
    },

    handleDeleteDetails(_, row) {
      this.detailsForm = { ...row };
      SweetAlert.delete(
        i18n.t('sweet_alert.jobs.associated_data') +
          this.detailsForm.activity.name
      ).then((result) => {
        if (result.value) this.deleteDetail();
      });
    },

    updateTableAfterDelete(index, updateTableData = true) {
      if (index >= 0) {
        this.tableDataDetails.splice(index, 1);
        if (updateTableData) this.updateTableData();
        if (this.rowData.deleteHeader) {
          let index = this.tableData.findIndex(
            (tableRow) => tableRow.id === this.rowData.id
          );

          this.tableData.splice(index, 1);
          this.details = false;
        }
      }
    },

    deleteDetail() {
      this.showHideLoading(true);
      if (this.isDelete()) {
        if (this.tableDataDetails.length == 1) {
          this.rowData.deleteHeader = true;
        }

        this.detailsForm.route = 'works/labordetails';
        Axios.destroyMaster(this.detailsForm)
          .then(() => {
            let indexToDelete = this.tableDataDetails.findIndex(
              (tableRow) => tableRow.id === this.detailsForm.id
            );
            this.updateTableAfterDelete(indexToDelete);
            this.showHideLoading();
            this.showNotification(
              `${i18n.t('show_notification.jobs.deleted_detail')}${
                this.detailsForm.activity.name
              } ${i18n.t(
                'show_notification.jobs.successfully_selected_labor'
              )}.`,
              'success',
              'nc-simple-remove',
              i18n.t('common_words.successful_deletion')
            );
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    updateRowDetails(inTable, updateData, message) {
      this.$set(this.tableDataDetails, this.model.index, updateData);

      const row = {
        ...inTable,
        ...updateData,
      };
      this.calculateSubtotal(row, message, true);
    },

    deleteActivityReport() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'works/laborheaders';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.handleViewDetails();
            this.modifyTable(2, this.model.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    setupTable() {
      const { Table, TableDetails } = configTable();
      this.pagination = { ...Table.pagination };
      this.paginationDetails = { ...TableDetails.pagination };
      this.tableColumns = Table.tableColumns;
      this.tableColumnsDetails = TableDetails.tableColumns;
    },
  },
  created() {
    if (this.isIndex()) {
      this.setupTable();
      Axios.getMasters('works/workers/indexField').then((response_workers) => {
        this.workers = this.concatAll(response_workers.data.data);
        this.showHideLoading();
      });

      Axios.getMasters('works/activities/only/field').then(
        (response_activities) => {
          this.activities = this.concatAll(response_activities.data.data);
          this.showHideLoading();
        }
      );

      Axios.getMasters('works/timetypes/field').then((response_time_types) => {
        this.timeTypes = this.concatAll(response_time_types.data.data);
        this.showHideLoading();
      });
    } else {
      this.showMessageAccess();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },
  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
